import AdminViewHeader from "./AdminViewHeader.jsx";
import { NOTE_CLASS } from "../lib/ui.js";

export default function ScopedAdminPage({ title, scope, description, children }) {
    return (
        <>
            <AdminViewHeader title={title} scope={scope} />
            <div className="flex-1 min-h-0 min-w-0 overflow-y-auto py-[12px]">
                <div className="grid gap-[14px]">
                    {description ? (
                        <header className="grid gap-[3px] border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[12px] py-[10px]">
                            <p className={`${NOTE_CLASS} text-[11px] leading-[1.4]`}>{description}</p>
                        </header>
                    ) : null}
                    {children}
                </div>
            </div>
        </>
    );
}
